import { render, staticRenderFns } from "./CareersDetail.vue?vue&type=template&id=7870cd0a&"
import script from "./CareersDetail.vue?vue&type=script&lang=js&"
export * from "./CareersDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports